'use client';

import { investmentKnowledgeQuestionnaire } from '@/app/[locale]/(legacy)/(auth)/sign-up/(funnel)/investment-knowledge-questionnaire/config';
import { useSignUpContext } from '@/app/[locale]/(legacy)/(auth)/sign-up/_providers';
import { getPreviousSignUpStep } from '@/app/[locale]/(legacy)/(auth)/sign-up/config';
import { Button } from '@/app/_components/ui/button';
import { Icons } from '@/app/_components/ui/icons';
import Routes from '@/lib/router/routes';
import { usePathname, useRouter } from '@/lib/translation/hooks';

interface PreviousButtonCommonProps {
  className?: string;
  arrowClassName?: string;
}

const PreviousButtonCommon = ({
  className,
  arrowClassName,
}: PreviousButtonCommonProps) => {
  const { previousCallback } = useSignUpContext();
  const router = useRouter();
  const pathname = usePathname();

  const previousSignUpStep = getPreviousSignUpStep(pathname);

  const onClick = () => {
    if (previousCallback) {
      return previousCallback();
    }

    // Handle the fact that when we go the last step of the quizz (risk awareness)
    // with the previous button, we send it to the last question
    if (previousSignUpStep === Routes.SignUpRiskAwareness) {
      const searchParams = new URLSearchParams({
        currentQuestionIndex: (
          investmentKnowledgeQuestionnaire[
            investmentKnowledgeQuestionnaire.length - 1
          ].questions.length - 1
        ).toString(),
      });

      return router.push(`${previousSignUpStep}?${searchParams.toString()}`);
    }

    return router.push(getPreviousSignUpStep(pathname));
  };

  return (
    <Button onClick={onClick} variant="ghost" size="icon" className={className}>
      <Icons.LeftArrow className={arrowClassName} />
    </Button>
  );
};

export default PreviousButtonCommon;
